import React, { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import { EmailIcon, KeyboardArrowDownIcon, NotificationsIcon, PersonIcon, LogoutIcon } from "../../utils/icons";
import CommonModal from "../../Components/Modals/index";
import "./profile.scss";
import { useNavigate } from "react-router-dom";

const HeaderProfile = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [modal, setModal] = useState(false);
  const navigate = useNavigate();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const user = JSON.parse(localStorage.getItem("access_token"));

  const handleClose = () => {
    setAnchorEl(null);
  };

  const dropdownItems = [
    { name: "My Profile",
      icon: <PersonIcon sx={{height:"18px",width:"18px"}}/>, 
      path: (() => {
    switch (user.role) {
      case 1:
        return "/super/profile";
      case 2:
        return "/sub/profile";
      default:
        return "/end/profile";
    }
  })()  },
    { name: "Log Out", icon: <LogoutIcon sx={{height:"18px",width:"18px"}}/>, path: "/login" },
  ];

  const handleNav = (path) => {
    if (path === "/login") {
      setModal(!modal);
      // localStorage.removeItem('access_token');
    } else {
      navigate(path);
    }
    setAnchorEl(null);
  };

  const logoutConfirmation = ()=>{
          localStorage.removeItem('access_token');
          localStorage.removeItem('logo');
          localStorage.removeItem('group');
          localStorage.removeItem('id');
          localStorage.removeItem('name');
          localStorage.removeItem('userid');
          localStorage.removeItem("groupName");
          localStorage.removeItem("cname");
          navigate("/login")
  }
  return (
    <div className='headerContainer1'>
      <div className='rightProfile' onClick={handleClick}>
        <div className='profile_dropdown'>
          <img src={user.role === 1 ? '/assets/images/adminLogo.png' : `${localStorage.getItem('logo')}`}  alt='profile' style={{ cursor: "pointer",height:"28px",width:"28px",borderRadius:"50%" }}/>
          <div className='textSection'  style={{ cursor: "pointer",marginTop:"0px" }}>
            {user.role === 1 ? "Super Admin":`${localStorage.getItem('name')}`}
          </div>
          <div className='padLft'>
            <KeyboardArrowDownIcon  style={{ color: "#4D4D4D", cursor: "pointer" }} />
          </div>


        </div>
        {user.role === 3 &&
        <div style={{marginLeft:"36px"}}>
        <div className='textSection'  style={{ cursor: "pointer",marginTop:"0px" }}>
            {user.role === 1 ? "Super Admin":`${localStorage.getItem('cname')}`}
          </div>
        </div>
        }

      </div>
      <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            autoFocus={false}
            sx={{
              "& .MuiPaper-root": {
                minWidth: "11.042vw",
                borderRadius: "0.417vw",
                border: "1px solid #CCCCCC",
                marginTop: "5px",
              },
              "& .MuiList-root": {
                padding: "0px",
              },
            }}>
            {dropdownItems.map((item, index) => (
              <MenuItem
                key={index}
                onClick={() => {
                  handleNav(item.path);
                }}
                style={{
                  border: "1px solid #E6E6E6",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
                sx={{
                  padding: "7px",
                }}>
          <div style={{marginTop:"5px"}}>{item.icon}</div>
          <div style={{fontSize:"12px"}}>{item.name}</div>
              </MenuItem>
            ))}
          </Menu>
      {modal && (
        <CommonModal
          setIsOpenPopUp={setModal}
          open={modal}
          // isLoading={isLoading}
          handleDelete={logoutConfirmation}
          item={{
            title: "Logout",
            description: "Are you sure you want to logout?",
            icon: false,
          }}
        />
      )}
    </div>
  );
};

export default HeaderProfile;
